import Application from "../../Application";
import GetDocumentTypeVisibilityLevelInteractor from "../../documentTypes/interactors/GetDocumentTypeVisibilityLevelsInteractor";
import Constants from "../common/Constants";

export default class GetCaseLawDocumentTypeVisibilityLevelsInteractor {
  private application: Application;
  private getDocumentTypeVisibilityLevelInteractor: GetDocumentTypeVisibilityLevelInteractor;

  constructor({ application, getDocumentTypeVisibilityLevel }) {
    this.application = application;
    this.getDocumentTypeVisibilityLevelInteractor =
      getDocumentTypeVisibilityLevel;
  }

  execute(organisationId: number, caseLawDocumentTypeId: number) {
    return this.getDocumentTypeVisibilityLevelInteractor.execute(
      `${Constants.organisationsPath}/${organisationId}/${Constants.caseLawDocumentTypePath}/${caseLawDocumentTypeId}`
    );
  }
}
